var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import { Breadcrumb as BreadcrumbInterface } from '@/support/Breadcrumb';
let Breadcrumb = class Breadcrumb extends Vue {
};
__decorate([
    Model('crumb'),
    __metadata("design:type", typeof (_a = typeof BreadcrumbInterface !== "undefined" && BreadcrumbInterface) === "function" ? _a : Object)
], Breadcrumb.prototype, "crumb", void 0);
Breadcrumb = __decorate([
    Component({})
], Breadcrumb);
export default Breadcrumb;
